<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters justify="center" align="center">

      <v-col class="pr-2">
        <v-text-field
          ref="input_value"
          v-model="input_value"
          :placeholder="placeholder"
          :error-messages="!checkValid ? error_message: ''"
          solo
          @keyup.enter="submit"
          :autofocus="true"
        ></v-text-field>
      </v-col>
      <v-col 
            cols="auto"
            class="ml-auto mb-7">

        <v-btn dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">Submit</v-btn>
      </v-col>
    </v-row> -->
    <div class="selectBox">
      <div class="inquireForm">
        <label>{{placeholder}}  <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span>
        <strong class="error" v-if="!checkValid">{{error_message_2}}</strong></label>
        <v-row >
          <v-col class="mr-0">
            <input :type="input_type" class="formItem" ref="input_value" v-model="input_value" :placeholder="placeholder" @keyup.enter="submit">
          </v-col>
          <v-col cols="auto" v-if="label_name == 'loanamount'" class="d-flex align-center pl-0">
            <div>{{suffix_text}}</div>
          </v-col>
        </v-row>
      </div>
      <div class="submitBtn">
        <button :id="label_name" @click="submit" v-if="isFinalQuestion()" class="btn-final">いくら減るか確認</button>
        <button :id="label_name" @click="submit" v-else>次へ</button>
      </div>
      <div class="mt-5 px-10" v-if="isFinalQuestion()">
        <div><span style="font-size:small; font-weight:bold">必ず「<a href="/privacy.html" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>」をご一読いただき、同意のうえご利用下さい。<br>送信をもって法律相談の申し込みとさせていただきます。</span></div>
       <div><span style="font-size:small; font-weight:bold"><br></span></div>
        <div><span style="font-size:small; font-weight:bold">
借金の減額自体は弁護士が行う手続きです。<br>
正確な減額可能な金額や減額手続きの流れをお伝えするため上記事務所の担当者よりお電話やSMS送信でお問合せ（入力）5分以内を目安にご連絡させていただきます。
ご同意いただける場合、お申込み下さい。
</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js'

export default {

  name: "TextFieldInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'answer_type', 'label_name', 'question_id', 'answer_data', 'custom_validation'],

  created(){
    this.error_message_2 = this.error_message
    if (this.answer_type == 'email'){
      this.input_type = 'email'
    }
    if (this.answer_type == 'phone-number-no-hyphen' || this.answer_type == 'phone-number-hyphen' || this.answer_type == 'phone-number-both'){
      this.input_type = 'tel'
    }
  },

  data: () =>({
    input_value: "", 
    checkValid: true,
    input_type:'text',
    error_message_2: '',
    suffix_text: '万円'
  }),

  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      if (this.validateInput() == true){
        var _input_value = this.input_value
        if (this.label_name == 'loanamount'){
          _input_value = _input_value + this.suffix_text
        }
        var emitValue = {user_chat_message: _input_value, user_chat_value:_input_value}
        this.$emit('text_input_submitted', emitValue)
        this.input_value = ''
      }else{
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
    },

    customValidation(_input_value){
      if (this.custom_validation.length > 0){
        this.error_message_2 = ''
        var temp_answer_data = JSON.parse(JSON.stringify(this.answer_data))
        temp_answer_data.push({ 'key': this.label_name, 'value': _input_value, 'question_id': this.question_id })

        for(var i=0; i < this.custom_validation.length; i++){
          if (this.custom_validation[i].rule != ''){
            var validation_result = utils.runCustomValidation(this.custom_validation[i].rule, temp_answer_data)
            if (validation_result == false){
              this.error_message_2 = this.custom_validation[i].error_message
              return false
            }
          }
        }
      }
      return true
    },

    validateInput(){
      //console.log(this.input_value)
      this.error_message_2 = this.error_message // reset error message
      this.checkValid = true
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          if (this.customValidation(this.input_value) == false) {
            this.checkValid = false
            return false
          }else{
            return true
          }
        }else{
          this.checkValid = false
          return false
        }
      }else{
        return true
      }
    },

    isFinalQuestion(){
      if (this.label_name.indexOf('final') === 0){
        return true
      }else{
        return false
      }
    }

  }

}
</script>